import axioApi, { setHeader } from 'api/root.api';

export const applyModelIcon = async (body, token, projectId, modelId)=>{
    const urlEnd = `/editor/project/v1/${projectId}/${modelId}/applyModelIcon`;
    // setHeader('Access-Control-Allow-Origin', '*');
    setHeader('Content-Type', 'application/json');
    const response = await axioApi.post(urlEnd, body);
    const result = response.data;
    return result;
};